import { render, staticRenderFns } from "./HowToSection.vue?vue&type=template&id=2fcb7b7b&"
import script from "./HowToSection.vue?vue&type=script&lang=js&"
export * from "./HowToSection.vue?vue&type=script&lang=js&"
import style0 from "./HowToSection.vue?vue&type=style&index=0&id=2fcb7b7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports